import {GET_TASK_LIST, UPDATE_TASK_LIST} from "./availableActions";
import {GetTaskListData, UpdateTaskListData} from "../../interfaces/store/actions/payload/task";
import {GetTaskListAction, UpdateTaskListAction} from "../../interfaces/store/actions/task";

export const getTaskList = (payload?: GetTaskListData): GetTaskListAction => ({
    type: GET_TASK_LIST,
    payload,
});

export const updateTaskList = (payload: UpdateTaskListData): UpdateTaskListAction => ({
    type: UPDATE_TASK_LIST,
    payload,
});
